<template>
  <div class="page-container">
    <h4>路下巡回点検 {{pageName}}</h4>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'roka-tenken',
  computed: {
    ...mapGetters('displayPageName', [
      'pageName',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  margin: 10px 30px 30px;
}
</style>
